const locked = new Set()

export const scrollLock = (lockElement: HTMLElement) => {
  locked.add(lockElement)
  document.body.style.setProperty('overflow', 'hidden')
}

export const scrollUnlock = (lockElement: HTMLElement) => {
  locked.delete(lockElement)

  if (locked.size === 0) {
    document.body.style.removeProperty('overflow')
  }
}
